import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import CollectionCatalog from "@/pages/CollectionCatalog";
import AdminWaitlist from "@/pages/AdminWaitlist";
import Allocation from "@/pages/Allocation";

/**
 * Reset window scroll to the top on every pathname change.
 * Skips when a hash is present so deep-links to a specific
 * watch (e.g. /collection/launch#rosewood-charcoal) can still
 * scroll-target their own element after mount.
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/collection/:slug" element={<CollectionCatalog />} />
          <Route path="/allocation" element={<Allocation />} />
          <Route path="/admin/waitlist" element={<AdminWaitlist />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#161B14",
            color: "#F5F2EB",
            border: "1px solid rgba(197,160,89,0.3)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
